import { LitElement, html, svg } from 'lit';

export class IconTriangle24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" fill="none" viewBox="0 0 24 25"><title>Varseltrekant</title><path stroke="currentColor" stroke-width="1.5" d="m1.068 21.105 9.375-19.491C10.98.495 12.566.476 13.13 1.582l9.953 19.491a1.5 1.5 0 0 1-1.336 2.182H2.42a1.5 1.5 0 0 1-1.352-2.15Z"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 9v7.488M12 19.5v.5"></path></svg>`; }
}
if (!customElements.get('f-icon-triangle24', IconTriangle24)) {
  customElements.define('f-icon-triangle24', IconTriangle24);
}